import { actionTypes } from '../constants/actionTypes';
import api from '../services';

export const fetchHeaderMenusWP = (data) => {
    return (dispatch) => {
        dispatch(request({
            loading: true
        }));
        api.getPosts(data).then(response => {
            dispatch(success({
                data: response.data,
                error: null,
                loading: false,
                total: response.total
            }));
        }).catch(error => {
            dispatch(failure({
                data: [],
                error: error.message,
                loading: false,
                total: 0
            }));
        });
    };

    function request(payload) {
        return {type: actionTypes.FETCH_WP_HEADER_MENUS, payload};
    }

    function success(payload) {
        return {type: actionTypes.FETCH_WP_HEADER_MENUS_SUCCESS, payload};
    }

    function failure(payload) {
        return {type: actionTypes.FETCH_WP__HEADER_MENUS_FAIL, payload};
    }
};



// WEBPACK FOOTER //
// ./src/actions/headerMenus.tsx